module.exports = __webpack_public_path__ + "img/portal.0f29fa0a.png";